export default __webpack_public_path__ + "static/media/apple-iPhone12.6376860c.jpg";